"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SERVICE_RESULTS = void 0;
exports.GET_SERVICE_RESULTS = {
    total: 3,
    rhsLevel: 'rhs1',
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '8821',
                featureName: 'Cot Available',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6428',
                featureName: 'Highchair Available',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6275',
                featureName: 'Dishwasher',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '3084',
                featureName: 'Hot Tub - Private',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9857',
                featureName: 'Pet(s) Allowed',
                featureCode: null,
                count: 1,
            },
        ],
        siteFeatures: [
            {
                featureId: '3506',
                featureName: 'Autograph Lodges',
                featureCode: 'SPECCOLL',
                count: 1,
            },
            {
                featureId: '3732',
                featureName: 'WiFi',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9153',
                featureName: 'Luxury',
                featureCode: 'SUPER',
                count: 1,
            },
        ],
        bathrooms: [{ bathrooms: 0, count: 3 }],
        bedrooms: [{ bedrooms: 2, count: 3 }],
        regions: {
            rhs1: [{ region: 'England', count: 1, id: 21667 }],
            rhs2: [{ region: 'Central England', count: 1, id: 21808 }],
            rhs3: [{ region: 'Shropshire', count: 1, id: 21880 }],
            rhs4: [{ region: 'Shropshire', count: 1, id: 21881 }],
            rhs5: [{ region: 'Oswestry', count: 1, id: 21887 }],
        },
        grades: [],
    },
    properties: [
        {
            code: 'LP18304',
            displayName: 'Heron',
            location: 'Lodge | Winston Farm Lodges | LP18304',
            property: { pets: 0, sleeps: 4, bathrooms: 0, bedrooms: 2 },
            images: [
                {
                    assetId: 'WINL-LP18304_EX01A_19',
                    caption: 'Heron | Winston Farm Lodges, Tetchill',
                },
            ],
            priceFrom: 649,
            startDate: '2023-05-01',
            reviewCount: 24,
            averageReviewScore: 9.3,
            USPs: [
                { id: '6948', value: 'Wifi' },
                { id: '10408', value: 'Car parking on site' },
                { id: '6455', value: 'Pub within 1 mile' },
            ],
            cardinality: 'SINGLE',
        },
        {
            code: 'LP18305',
            displayName: 'Kingfisher',
            location: 'Winston Farm Lodges | LP18305',
            property: { pets: 0, sleeps: 4, bathrooms: 0, bedrooms: 2 },
            images: [
                {
                    assetId: 'WINL-LP18305_EX02A_19',
                    caption: 'Kingfisher | Winston Farm Lodges, Tetchill',
                },
            ],
            priceFrom: 675,
            startDate: '2023-05-01',
            reviewCount: 9,
            averageReviewScore: 9.9,
            USPs: [
                { id: '9153', value: 'Luxury' },
                { id: '6948', value: 'Wifi' },
                { id: '10408', value: 'Car parking on site' },
            ],
            cardinality: 'SINGLE',
        },
        {
            code: 'LP18306',
            displayName: 'Lapwing',
            location: 'Park | Winston Farm Lodges | LP18306',
            property: { pets: 1, sleeps: 4, bathrooms: 0, bedrooms: 2 },
            images: [
                {
                    assetId: 'WINL-LP18306_IN02A_19',
                    caption: 'Lapwing | Winston Farm Lodges, Tetchill',
                },
            ],
            priceFrom: 675,
            startDate: '2023-05-01',
            reviewCount: 9,
            averageReviewScore: 9.9,
            USPs: [
                { id: '9153', value: 'Luxury' },
                { id: '6948', value: 'Wifi' },
                { id: '10408', value: 'Car parking on site' },
            ],
            cardinality: 'SINGLE',
        },
    ],
};
//# sourceMappingURL=getServiceResults.js.map